import { ClassFlag } from "../../library-js/dom-tools/ClassFlag";
import { ElementAttribute } from "../../library-js/dom-tools/ElementAttribute";
import { ElementType } from "../../library-js/dom-tools/ElementType";
import { OnClick, OnPause, OnPlay } from "../../library-js/dom-tools/EventListeners";
import { RJLog } from "../../library/ts/node/log/RJLog";

export class OneAudioPlaying
{
  static readonly type = new ElementType( "one--audio--playing" );
  static readonly selector = new ElementAttribute( "selector" );
  static readonly toggles = new ElementAttribute( "toggles" );

  static applyOnDocument()
  {
    OneAudioPlaying.type.forAllInDoc( e => OneAudioPlaying.applyOnElement( e ) );
  }

  static applyOnElement( element:Element )
  {
    let audioContainers = OneAudioPlaying.selector.queryValueAllInDoc( element );

    let muteAudio = ( exception:Element ) =>
    {
      audioContainers.forEach(
        ( ac )=>
        {
          if ( ac === exception )
          {
            return;
          }

          let audio = ElementType.audio.query( ac );
          ClassFlag.playing.removeFrom( ac );  

          if ( audio.paused )
          {
            return;
          }

          audio.pause();
          
        }
      ) 
    }

    let toggleAudio = ( audioContainer:Element ) =>
    {
      let currentAudio = ElementType.audio.query( audioContainer );

      if ( ! currentAudio.paused )
      {
        currentAudio.pause();
        return;
      }

      muteAudio( audioContainer );
      currentAudio.play();


    }

    audioContainers.forEach(
      ( ac )=>
      {
        
        let toggles = OneAudioPlaying.toggles.queryValueAllIn( element, ac );

        RJLog.log( ac,  OneAudioPlaying.toggles.from( element ), toggles );

        toggles.forEach(
          ( t )=> OnClick.add( t as HTMLElement, ()=> toggleAudio( ac ) ) 
        );

        let audio = ElementType.audio.query( ac );
        OnPlay.add( audio, 
          () =>
          {
            muteAudio( ac ) 
            ClassFlag.playing.set( ac );            
          } 
        );

        OnPause.add( audio, 
          ()=>
          {
            ClassFlag.playing.removeFrom( ac );  
          }
        )
      }
    );
  }

}